/* eslint-disable no-unused-vars */
import { useMemo } from 'react';

import { PictureIcon } from 'assets/icons';
import { ImageWithFallback, ParagraphWithTooltip } from 'components';
import { format } from 'date-fns';
import styled, { css } from 'styled-components';
import { Palette } from 'config';

const creativeNameStyle = {
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '20px',
};

export const ListItem = ({ selectedImg$, item, searchValue$ }) => {
  return (
    <CreativeItem
      onClick={() => (selectedImg$.value = item)}
      isSelected={selectedImg$.value?.media_id === item?.media_id}
    >
      <PictureIcon />
      <ImageWithFallback
        key={item.media_id}
        width='32px'
        height='32px'
        src={`https://cdn.appnext.com/banner/${item.file_name}`}
      />
      <ParagraphWithTooltip
        text={item.file_name || item.name || 'no file name'}
        style={creativeNameStyle}
        isHighlight
        search={searchValue$.value}
      />
      <DateBox>{format(new Date(item.upload_date), 'dd/MM/yyyy')}</DateBox>
    </CreativeItem>
  );
};

const CreativeItem = styled.div`
  display: flex;
  border: 1px solid ${Palette.PrimaryGray._000};
  height: 48px;
  gap: 16px;
  align-items: center;
  justify-content: start;
  padding: 8px;
  border-radius: 4px;

  cursor: pointer;
  svg {
    fill: #94a3b8;
  }
  :hover {
    background: ${Palette.PrimaryGray._100};
    svg {
      fill: #64748b;
    }
  }

  :active {
    border: 1px solid ${Palette.Primary._300};
    background: ${Palette.Primary._000};
    svg {
      fill: ${Palette.Primary._500};
    }
    /* p {
      color: ${Palette.PrimaryGray._900};
    } */
  }
  ${({ isSelected }) =>
    isSelected &&
    css`
      border: 1px solid ${Palette.Primary._300};
      background: ${Palette.Primary._000};
      svg {
        fill: ${Palette.Primary._500};
      }
      /* p {
        color: ${Palette.PrimaryGray._900};
      } */
    `}
`;

const DateBox = styled.p`
  margin-left: auto;
  color: ${Palette.PrimaryGray._500};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;
